import { render, staticRenderFns } from "./ActionHero.vue?vue&type=template&id=2fe7ae7d&scoped=true&"
import script from "./ActionHero.vue?vue&type=script&lang=js&"
export * from "./ActionHero.vue?vue&type=script&lang=js&"
import style0 from "./ActionHero.vue?vue&type=style&index=0&id=2fe7ae7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe7ae7d",
  null
  
)

export default component.exports